var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "com-upload", attrs: { id: _vm.uploadContainerId } },
    [
      _c(
        "el-upload",
        {
          ref: _vm.uploadContainerId,
          attrs: {
            action: _vm.action,
            name: _vm.name,
            headers: _vm.extraHeaders,
            limit: _vm.limit,
            "file-list": _vm.fileList,
            "with-credentials": _vm.withCredentials,
            drag: _vm.drag,
            accept: _vm.fileAccept,
            multiple: _vm.limit > 1 && _vm.multiple,
            "list-type": _vm.listType,
            "auto-upload": _vm.autoUpload,
            "show-file-list": _vm.showFileList,
            "on-preview": _vm.onPreview,
            "before-remove": _vm.beforeRemove,
            "on-remove": _vm.onRemove,
            "on-success": _vm.onSuccess,
            "on-error": _vm.onError,
            "on-progress": _vm.onProgress,
            "on-change": _vm.onChange,
            "before-upload": _vm.beforeUpload,
            "on-exceed": _vm.onExceed,
            disabled: _vm.disabled,
          },
        },
        [
          _vm.listType === "picture-card"
            ? [
                _c("i", { staticClass: "el-icon-plus com-upload_icon" }),
                _vm.desc
                  ? _c("span", { staticClass: "com-upload_desc" }, [
                      _vm._v(_vm._s(_vm.desc)),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.listType == "text"
            ? [
                _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                  _vm._v(_vm._s(_vm.btnText)),
                ]),
              ]
            : _vm._e(),
          _vm._t("default"),
        ],
        2
      ),
      ["image", "video", "audio"].includes(_vm.fileType)
        ? [
            _c("file-preview", {
              ref: "filePreview",
              attrs: {
                type: _vm.fileType,
                index: _vm.currentPreviewIndex,
                "show-file-list": false,
                list: _vm.previewFileUrls,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }